import { ContractorGroupData } from "../to-be-removed/LocalData/ContractorGroup/ContractorGroupData";
import { UserData } from "../to-be-removed/LocalData/User/UserData";
import { PropertyData } from "../to-be-removed/LocalData/Property/PropertyData";
import { CompanyData } from "../to-be-removed/LocalData/Company/CompanyData";
import { StringUtilities } from "./stringUtilities";
import { ArrayUtilities } from "./arrayUtilities";
import { ReadAccess } from "../to-be-removed/LocalData/General/AccessData";
import { Role } from "../to-be-removed/LocalData/User/Role";
import { LocalData } from "../to-be-removed/LocalData/General/LocalData";
import i18next, { t } from "i18next";
import { DocumentReference, Timestamp } from "firebase/firestore";
import { getPropertyRolesFlatList, getPropertyRolesLists } from "to-be-removed/api/utiles/userRights.utils";
import { LanguageCode, getCurrentNormalizedLanguageCode, getNormalizedLanguageCode } from "@src/libs/i18next/language";
import { getPluralRoleTitle } from "./data/roles.utils";
import { IRawCompanySettingsGeneral } from "@propely/propely-typings";
import { getCachedApiSettings } from "@src/data-hooks/general-settings/settings.service";

export class Utilities {
  static getReadAccess(data: any): ReadAccess {
    return this.getOptionalReadAccess(data) || {};
  }
  static getOptionalReadAccess(data: any): ReadAccess | undefined {
    if (typeof data === "object") {
      const access: ReadAccess = {};
      if (Array.isArray(data.roles)) {
        access.roles = [];
        for (const role of data.roles) {
          access.roles.push(Role.getRoleWithId(role));
        }
      }
      access.companies = Array.isArray(data.companies) ? data.companies.map((c: string) => LocalData.companies.addData(c)) : [];
      access.contractorGroups = Array.isArray(data.contractorGroups)
        ? data.contractorGroups.map((c: string) => LocalData.contractorGroups.addData(c))
        : [];
      access.properties = Array.isArray(data.properties) ? data.properties.map((c: string) => LocalData.properties.addData(c)) : [];
      access.users = Array.isArray(data.users) ? data.users.map((u: string) => LocalData.users.addData(u)) : [];

      if (Array.isArray(data.propertyUnits)) {
        access.propertyUnits = [];
        for (const u of data.propertyUnits) {
          const elements = u.split("/");
          if (elements.length !== 2) continue;
          const property = LocalData.currentUser.properties.find((p) => p.id === elements[0]);
          if (property?.hasAccessToUnit(elements[1])) access.propertyUnits.push(property.getUnitWithId(elements[1]));
        }
      }
      if (Array.isArray(data.propertyRoles)) {
        access.propertyRoles = [];
        for (const r of data.propertyRoles) {
          const elements = r.split("/");
          if (elements.length !== 2) continue;
          const property = LocalData.currentUser.properties.find((p) => p.id === elements[0]);
          const role = parseInt(elements[1]);
          if (property && typeof role === "number" && !isNaN(role)) access.propertyRoles.push({ property, role: Role.getRoleWithId(role) });
        }
      }

      return access;
    }
    return undefined;
  }

  /**
   * @deprecated use useReadAccessText hook instead
   */
  static getReadAccessString(access: ReadAccess | undefined, settings?: { excludePropertyRoles?: boolean }): string {
    let value: string[] = [];
    if (!access) return "";
    if (access.roles && access.roles.length > 0)
      value.push(access.roles.map((role) => getPluralRoleTitle(role.id, getCachedApiSettings({})?.data)).join(", "));
    if (access.contractorGroups && access.contractorGroups.length > 0 && !access.roles?.includes(Role.ENTREPRENEUR))
      value.push(StringUtilities.createString(access.contractorGroups.map((c) => c.name)));
    if (access.properties && access.properties.length > 0) value.push(StringUtilities.createString(access.properties.map((c) => c.name)));
    if (access.companies && access.companies.length > 0) value.push(StringUtilities.createString(access.companies.map((c) => c.name)));
    if (access.users && access.users.length > 0) value.push(StringUtilities.createString(access.users.map((c) => c.name)));
    if (access.propertyUnits && access.propertyUnits.length > 0) value.push(StringUtilities.createString(access.propertyUnits.map((c) => c.name)));

    if (access.propertyRoles && access.propertyRoles.length > 0 && !settings?.excludePropertyRoles) {
      const propertyRoles = access.propertyRoles.sort((a, b) => a.property.name.localeCompare(b.property.name));
      const groupedPropertyRoles: { [key: string]: { roles: string[]; property: PropertyData } } = {};
      for (const propertyRole of propertyRoles) {
        if (!groupedPropertyRoles[propertyRole.property.id])
          groupedPropertyRoles[propertyRole.property.id] = { roles: [], property: propertyRole.property };
        groupedPropertyRoles[propertyRole.property.id].roles.push(getPluralRoleTitle(propertyRole.role.id, undefined));
      }
      value.push(StringUtilities.createString(Object.values(groupedPropertyRoles).map((c) => c.property.name)));
    }

    return StringUtilities.createString(value);
  }

  /**
   * @deprecated use useReadAccessText hook instead
   */
  static getReadAccessBasicString(access: ReadAccess | undefined): string {
    let value: string[] = [];
    if (!access) return "";
    if (access.roles && access.roles.length > 0) value.push(access.roles.map((role) => getPluralRoleTitle(role.id, undefined)).join(", "));
    if (access.contractorGroups && access.contractorGroups.length > 0)
      value.push(StringUtilities.createString(access.contractorGroups.map((c) => c.name)));
    if (access.properties && access.properties.length > 0) value.push(StringUtilities.createString(access.properties.map((c) => c.name)));
    if (access.companies && access.companies.length > 0) value.push(StringUtilities.createString(access.companies.map((c) => c.name)));
    if (access.users && access.users.length > 0) value.push(StringUtilities.createString(access.users.map((c) => c.name)));
    if (access.propertyUnits && access.propertyUnits.length > 0) value.push(StringUtilities.createString(access.propertyUnits.map((c) => c.name)));
    if (access.propertyRoles) {
      const propertyRoles = access.propertyRoles.sort((a, b) => a.property.name.localeCompare(b.property.name));
      const groupedPropertyRoles: { [key: string]: { roles: string[]; property: PropertyData } } = {};
      for (const propertyRole of propertyRoles) {
        if (!groupedPropertyRoles[propertyRole.property.id])
          groupedPropertyRoles[propertyRole.property.id] = { roles: [], property: propertyRole.property };
        groupedPropertyRoles[propertyRole.property.id].roles.push(getPluralRoleTitle(propertyRole.role.id, undefined));
      }
      value.push(StringUtilities.createString(Object.values(groupedPropertyRoles).map((c) => c.property.name + " (" + c.roles.join(", ") + ")")));
    }

    return StringUtilities.createString(value);
  }

  static loadReadAccess(access: ReadAccess): Promise<any> {
    let allPromises: Promise<any>[] = [];
    for (const data of access.contractorGroups?.filter((data) => !data.loaded) ?? []) allPromises.push(data.load());
    for (const data of access.companies?.filter((data) => !data.loaded) ?? []) allPromises.push(data.load());
    for (const data of access.properties?.filter((data) => !data.loaded) ?? []) allPromises.push(data.load());
    for (const data of access.users?.filter((data) => !data.loaded) ?? []) allPromises.push(data.load());
    for (const data of access.propertyUnits?.filter((data) => !data.loaded) ?? []) allPromises.push(data.load());
    for (const data of access.propertyRoles?.filter((data) => !data.property.loaded) ?? []) allPromises.push(data.property.load());

    return Promise.all(allPromises);
  }

  static convertReadAccess(access: ReadAccess | undefined): { [key: string]: any } {
    let returnValue: { [key: string]: any } = {};
    if (access) {
      if (access.roles && access.roles.length > 0) returnValue.roles = access.roles.map((role) => role.id);
      if (access.contractorGroups && access.contractorGroups.length > 0) returnValue.contractorGroups = access.contractorGroups.map((c) => c.id);
      if (access.companies && access.companies.length > 0) returnValue.companies = access.companies.map((c) => c.id);
      if (access.properties && access.properties.length > 0) returnValue.properties = access.properties.map((c) => c.id);
      if (access.users && access.users.length > 0) returnValue.users = access.users.map((u) => u.id);
      if (access.propertyRoles && access.propertyRoles.length > 0)
        returnValue.propertyRoles = access.propertyRoles.map((role) => role.property.id + "/" + role.role.id);
      if (access.propertyUnits && access.propertyUnits.length > 0)
        returnValue.propertyUnits = access.propertyUnits.map((unit) => unit.property?.id + "/" + unit.id);
    }

    return returnValue;
  }

  static convertReadAccessFromPropertyRoles(access: ReadAccess | undefined, includeContractors: boolean): { [key: string]: any } {
    let returnValue: { [key: string]: any } = {};
    if (access) {
      if (access.propertyRoles && access.propertyRoles.length > 0) {
        returnValue.propertyRoles = access.propertyRoles.map((role) => role.property.id + "/" + role.role.id);

        if (includeContractors) {
          for (const role of access.propertyRoles) {
            if (!(returnValue.propertyRoles as string[]).includes(role.property.id + "/" + Role.ENTREPRENEUR.id)) {
              returnValue.propertyRoles.push(role.property.id + "/" + Role.ENTREPRENEUR.id);
            }
          }
        }
      }
      if (access.propertyUnits && access.propertyUnits.length > 0) {
        returnValue.propertyUnits = access.propertyUnits.map((unit) => unit.property?.id + "/" + unit.id);
      }
    }
    return returnValue;
  }

  static hasAccess(data?: ReadAccess, propertyID?: string): boolean {
    if (!data) return false;

    // Temporary LocalData fix because this function is used a lot of places
    const property = propertyID ? LocalData.properties.getData(propertyID) : undefined;

    if (data.properties && data.properties.some((property) => LocalData.currentUser.properties.includes(property))) {
      return true;
    }

    if (property && data.roles && property.members.getData(LocalData.currentUser.id)?.roles.some((role) => data.roles?.includes(role))) {
      return true;
    }

    if (data.companies && data.companies.some((company) => LocalData.currentUser.companies.includes(company))) {
      return true;
    }

    if (data.contractorGroups && data.contractorGroups.some((contractorGroup) => LocalData.currentUser.contractorGroups.includes(contractorGroup))) {
      return true;
    }

    if (data.propertyUnits && property) {
      const unitsIds = property.members.getData(LocalData.currentUser.id)?.units.map((unit) => unit.id) ?? [];
      if (data.propertyUnits.some((unitData) => unitsIds.includes(unitData.id))) {
        return true;
      }
    }

    if (data.propertyRoles?.length) {
      const propertRoles = getPropertyRolesFlatList();
      if (
        propertRoles.some((propertyRole) => {
          const [propertyId, roleId] = propertyRole.split("/");
          return data.propertyRoles?.some((role) => role.property.id === propertyId && role.role.id === parseInt(roleId));
        })
      ) {
        return true;
      }
    }

    if (data.users && data.users.includes(LocalData.currentUser)) {
      return true;
    }
    return false;
  }

  static mergeReadAccess(first: ReadAccess | undefined, second: ReadAccess | undefined): ReadAccess {
    let properties = [...new Set([...(first?.properties ?? []), ...(second?.properties ?? [])])];
    let roles = [...new Set([...(first?.roles ?? []), ...(second?.roles ?? [])])];
    let companies = [...new Set([...(first?.companies ?? []), ...(second?.companies ?? [])])];
    let contractorGroups = [...new Set([...(first?.contractorGroups ?? []), ...(second?.contractorGroups ?? [])])];
    let users = [...new Set([...(first?.users ?? []), ...(second?.users ?? [])])];
    let propertyUnits = [...new Set([...(first?.propertyUnits ?? []), ...(second?.propertyUnits ?? [])])];
    let propertyRoles = [...new Set([...(first?.propertyRoles ?? []), ...(second?.propertyRoles ?? [])])];

    return {
      properties,
      roles,
      companies,
      contractorGroups,
      users,
      propertyUnits,
      propertyRoles,
    };
  }

  static capitalize(s: any) {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  static trimPhoneNumber(phone: string): string {
    return StringUtilities.replaceAll(StringUtilities.replaceAll(phone, "+", ""), " ", "");
  }
  static isValidPhoneNumber(phone: string): boolean {
    const trimmedPhone = this.trimPhoneNumber(phone);
    const phoneLength = trimmedPhone.length;
    return (phoneLength === 8 || phoneLength === 10) && (Number(trimmedPhone) ? true : false);
  }

  static areObjectsEqual(a: { [key: string]: any }, b: { [key: string]: any }): boolean {
    return (
      ArrayUtilities.areArraysEqual(Object.keys(a), Object.keys(b)) &&
      Object.keys(a).every((key) => {
        if (typeof a[key] === "object" && typeof b[key] === "object") {
          return this.areObjectsEqual(a[key], b[key]);
        } else {
          return a[key] === b[key];
        }
      })
    );
  }

  static arraysContainSameObject(aArray: any[], bArray: any[]): boolean {
    for (let a of aArray) {
      for (let b of bArray) {
        if (a.id === b.id) return true;
      }
    }
    return false;
  }

  static generateRGBArray(): number[] {
    return [Math.floor(Math.random() * 191), Math.floor(Math.random() * 191), Math.floor(Math.random() * 191)];
  }

  static generateInitials(text: string): string {
    if (text) {
      var initials = text.split(" ");
      if (initials) {
        var userInitials =
          (initials[0] ? initials[0].charAt(0) : "").toUpperCase() +
          (initials.length > 1 ? initials[initials.length - 1].charAt(0) : "").toUpperCase();
        return userInitials;
      }
    }
    return "";
  }

  static removeEmojis(text: string | number | Date) {
    if (typeof text === "number") return text;
    if (text instanceof Date) return Utilities.formatDate(text, "yyyy.mm.dd");
    return text
      .replaceAll(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, "")
      .replaceAll(/\s+/g, " ")
      .replaceAll(/️ /g, "")
      .trim();
  }

  static isKeyDownEnter(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter") {
      return true;
    } else if (event.keyCode === 13) {
      return true;
    }
    return false;
  }

  static generateDateString(date?: Date): string {
    if (!date) return "";
    if (Utilities.retrieveBrowser().name.toLowerCase() === "chrome") return Utilities.formatDate(date, "dd/mm/yyyy hh:MM");

    let options: Intl.DateTimeFormatOptions = {
      month: "short",
      year: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    return date.toLocaleString("nb-NO", options);
  }

  static timeSince(date?: Date) {
    if (!date) return "";

    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);

    var interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      return interval + " " + t("main.years") + " " + t("main.ago");
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return interval + " " + t("main.months") + " " + t("main.ago");
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
      return interval + " " + t("main.days") + " " + t("main.ago");
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
      return interval + " " + t("main.hours") + " " + t("main.ago");
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return interval + " " + t("main.minutes_abb") + " " + t("main.ago");
    }
    return Math.floor(seconds) + " " + t("main.seconds") + " " + t("main.ago");
  }

  static standardizeDate(date: Date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }

  static timeBetween(firstDate: Date, lastDate: Date) {
    let display: string = "";

    lastDate = Utilities.standardizeDate(new Date(lastDate));
    firstDate = Utilities.standardizeDate(new Date(firstDate));

    const monthsUntil = Utilities.monthsBetweenDates(firstDate, lastDate);
    const yearsUntil = Utilities.yearsBetweenDates(firstDate, lastDate);

    if (lastDate < firstDate) return t("main.expired");

    if (yearsUntil) {
      display += yearsUntil + ` ${t("main.years")} `;
    }

    if (monthsUntil) {
      let remainingMonths = monthsUntil - 12 * yearsUntil;
      display += remainingMonths + ` ${t("main.months")}`;
      //Sets new month, so we only need to calculate the days
      lastDate.setMonth(lastDate.getMonth() - monthsUntil);
    }

    const daysRemaining = Utilities.daysBetweenDates(firstDate, lastDate);

    if (!yearsUntil && !monthsUntil) {
      return Math.floor(daysRemaining) + ` ${t("main.days")}`;
    } else if (yearsUntil && monthsUntil) {
      return display;
    } else {
      return display + " " + Math.floor(daysRemaining) + ` ${t("main.days")}`;
    }
  }

  static timeUntil(date: Date): string {
    return Utilities.timeBetween(new Date(), date);
  }

  static generateStringFromNumberArray(array: number[]): string {
    let text = "";
    for (let i = 0; i < array.length; i++) {
      text += i !== 0 ? ", " + array[i] : array[i];
    }
    return text;
  }

  /**
   * @deprecated use map and join instead
   */
  static generateNameList(array: ContractorGroupData[] | CompanyData[]): string {
    let text = "";
    for (let i = 0; i < array.length; i++) {
      text += i !== 0 ? ", " + array[i].name : array[i].name;
    }
    return text;
  }

  /**
   * @deprecated use map and join instead
   */
  static generatePropertyNameList(properties: PropertyData[]): string {
    let text = "";
    for (let i = 0; i < properties.length; i++) {
      text += i !== 0 ? ", " + properties[i].name : properties[i].name;
    }
    return text;
  }

  /**
   * @deprecated use map and join instead
   */
  static generateUserList(array: UserData[]): string {
    let text = "";
    for (let i = 0; i < array.length; i++) {
      text += i !== 0 ? ", " + array[i].name : array[i].name;
    }
    return text;
  }

  static monthNames = [
    t("main.january"),
    t("main.february"),
    t("main.march"),
    t("main.april"),
    t("main.may"),
    t("main.june"),
    t("main.july"),
    t("main.august"),
    t("main.september"),
    t("main.october"),
    t("main.november"),
    t("main.december"),
  ];
  static formatDate(
    date: Date | undefined,
    format: "dd/mm/yyyy" | "dd.mm.yyyy" | "yyyy.mm.dd" | "dd/mmmm/yyyy" | "hh:MM" | "hh.MM" | "local" | "dd/mm/yyyy hh:MM" | "comparedDate-hh:mm"
  ): string {
    if (!date) return "";
    if (!(date instanceof Date)) return "";

    const monthNames = this.monthNames;

    let year = date.getFullYear();

    let month: number = date.getMonth();
    let monthName = monthNames[month];

    const day: number = date.getDate();
    const dayEnding = getNormalizedLanguageCode(i18next.language) === "no" ? "." : "th";

    let hours: string = date.getHours().toString();
    if (date.getHours() < 10) hours = "0" + date.getHours();

    let minutes: string = date.getMinutes().toString();
    if (date.getMinutes() < 10) minutes = "0" + date.getMinutes();

    const today = new Date();

    if (format === "dd/mm/yyyy" || format === "dd.mm.yyyy") {
      let divider = format === "dd/mm/yyyy" ? "/" : ".";
      month++;
      let dayString = "" + day;
      if (day < 10) dayString = "0" + day;
      const monthStr = "" + (month < 10 ? "0" + month : month);
      return dayString + divider + monthStr + divider + year;
    } else if (format === "yyyy.mm.dd") {
      month++;
      const monthStr = "" + (month < 10 ? "0" + month : month);
      return year + "." + monthStr + "." + day;
    } else if (format === "dd/mmmm/yyyy") {
      return day + dayEnding + " " + monthName + " " + year;
    } else if (format === "dd/mm/yyyy hh:MM") {
      month++;
      const monthStr = "" + (month < 10 ? "0" + month : month);
      return day + "." + monthStr + "." + year + ", " + hours + ":" + minutes;
    } else if (format === "hh:MM") {
      return hours + ":" + minutes;
    } else if (format === "hh.MM") {
      return hours + "." + minutes;
    } else if (format === "local") {
      const options: Intl.DateTimeFormatOptions = {
        month: "short",
        year: "numeric",
        day: "numeric",
      };
      return date.toLocaleString("nb-NO", options);
    } else if (format === "comparedDate-hh:mm") {
      let comparedDay = day + dayEnding + " " + monthName;
      if (today.getDate() === date.getDate()) {
        comparedDay = t("main.today");
      } else if (today.getDate() - 1 === date.getDate()) {
        comparedDay = t("main.yesterday");
      }
      return comparedDay + (year !== today.getFullYear() ? " " + year : "") + ", " + hours + ":" + minutes;
    }
    return "";
  }

  static formatTwoDates(date1: Date | undefined, date2: Date | undefined): string {
    let date = "";
    if (date1) {
      const options: Intl.DateTimeFormatOptions = {
        month: "short",
        year: date1.getFullYear() !== new Date().getFullYear() ? "numeric" : undefined,
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      date = date1.toLocaleString("nb-NO", options);
    }
    if (date2) {
      const options: Intl.DateTimeFormatOptions = {
        month: "short",
        year: date2.getFullYear() !== new Date().getFullYear() ? "numeric" : undefined,
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      date += " - " + date2.toLocaleString("nb-NO", options);
    } else {
      date += " - " + t("main.ongoing");
    }
    return date;
  }

  static isSameDate(firstDate: Date | undefined, lastDate: Date | undefined): boolean {
    return (
      firstDate?.getFullYear?.() === lastDate?.getFullYear?.() &&
      firstDate?.getMonth?.() === lastDate?.getMonth?.() &&
      firstDate?.getDate?.() === lastDate?.getDate?.()
    );
  }

  static formatDateTime(date?: Date): string {
    //  if (date) return Utilities.formatDate(date, "dd/mm/yyyy hh:MM");
    //  else return "";

    // @todo error using the below
    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      year: date?.getUTCFullYear() !== new Date().getUTCFullYear() ? "numeric" : undefined,
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    return date?.toLocaleString("nb-NO", options) ?? "";
  }

  static secondsBetweenDates(firstDate: Date, lastDate: Date): number {
    return (lastDate.getTime() - firstDate.getTime()) / 1000;
  }

  static daysBetweenDates(firstDate: Date, lastDate: Date): number {
    const secondsBetween = (lastDate.getTime() - firstDate.getTime()) / 1000;
    return secondsBetween / (60 * 60 * 24);
  }

  static monthsBetweenDates(firstDate: Date, lastDate: Date): number {
    let months = lastDate.getMonth() - firstDate.getMonth() + 12 * (lastDate.getFullYear() - firstDate.getFullYear());

    //Taking into account rounding down if less than a month between.
    if (firstDate.getDate() >= lastDate.getDate() && months) {
      months--;
    }

    return months;
  }

  static yearsBetweenDates(firstDate: Date, lastDate: Date): number {
    return Math.floor(Utilities.daysBetweenDates(firstDate, lastDate) / 365);
  }

  static hoursMinutesSecondsBetweenDates(firstDate: Date, lastDate: Date) {
    // get total seconds between the times
    let delta = Math.abs(lastDate.getTime() - firstDate.getTime()) / 1000;
    return this.formatSecondsBetween(delta);
  }

  static formatSecondsBetween(deltaSeconds: number) {
    // calculate (and subtract) whole hours
    const hours = Math.floor(deltaSeconds / 3600);
    deltaSeconds -= hours * 3600;
    let stringHours = hours + "";
    if (hours < 10) stringHours = "0" + hours;

    // calculate (and subtract) whole minutes
    const minutes = Math.floor(deltaSeconds / 60) % 60;
    deltaSeconds -= minutes * 60;
    let stringMinutes = minutes + "";
    if (minutes < 10) stringMinutes = "0" + minutes;

    // what's left is seconds
    const seconds = Math.floor(deltaSeconds) % 60;
    let stringSeconds = seconds + "";
    if (seconds < 10) stringSeconds = "0" + seconds;

    return stringHours + ":" + stringMinutes + ":" + stringSeconds;
  }

  static formatHumanReadableDuration(firstDate: Date, lastDate: Date) {
    let deltaSeconds = Utilities.secondsBetweenDates(firstDate, lastDate);
    let parts: string[] = [];

    // calculate (and subtract) whole hours
    const hours = Math.floor(deltaSeconds / 3600);
    deltaSeconds -= hours * 3600;
    if (hours > 0) {
      parts.push(hours + " " + (hours === 1 ? t("main.hour") : t("main.hours")));
    }

    // calculate (and subtract) whole minutes
    const minutes = Math.floor(deltaSeconds / 60) % 60;
    deltaSeconds -= minutes * 60;
    if (minutes > 0) {
      parts.push(minutes + " " + (minutes === 1 ? t("main.minute") : t("main.minutes")));
    }

    return parts.join(" " + t("main.and") + " ");
  }

  static dateWithinRange(date: Date | undefined, sDate: Date | undefined, eDate: Date | undefined): boolean {
    if (!sDate && !eDate) return true;
    if (date) {
      let startDate = undefined;
      if (sDate) {
        startDate = new Date(sDate.getTime());
        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);
        startDate.setMilliseconds(0);
      }
      let endDate = undefined;
      if (eDate) {
        endDate = new Date(eDate.getTime());
        endDate.setHours(0);
        endDate.setMinutes(0);
        endDate.setSeconds(0);
        endDate.setMilliseconds(0);
      }

      let incomingDate = new Date(date.getTime());
      incomingDate.setHours(0);
      incomingDate.setMinutes(0);
      incomingDate.setSeconds(0);
      incomingDate.setMilliseconds(0);
      if (!endDate || incomingDate.getTime() <= endDate.getTime()) {
        if (!startDate || incomingDate.getTime() >= startDate.getTime()) {
          return true;
        }
      }
    }
    return false;
  }

  static formatNumber(number: any): string {
    if (typeof number !== "number" || !number) return "0";
    number = Math.round(number);
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  static formatNumberOneDecimal(number: any) {
    if (typeof number !== "number" || !number) return "0";

    number = Math.round(number * 10) / 10;
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  static formatNumberDynamicDecimal(number: any) {
    if (typeof number !== "number" || !number) return "0";
    if (number > 0 && number < 1) {
      number = Math.round(number * 100) / 100;
    } else {
      number = Math.round(number);
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  static convertToNumber(value: any): number {
    if (value === undefined || value === null || value === "") return 0;
    if (typeof value === "number" && isFinite(value)) return value;
    if (typeof value === "string") {
      value = value.replace(/\s/g, "");
      value = value.replace(",", ".");
      if (!isNaN(parseFloat(value))) return parseFloat(value);
    }
    return 0;
  }

  static convertStringToDate(dateString: string): Date {
    try {
      let dateArray = dateString.split(".");
      let date = dateArray[0];
      let month = dateArray[1];
      let year = dateArray[2];

      let newDate = new Date();
      newDate.setDate(Number(date));
      newDate.setMonth(Number(month) - 1);
      newDate.setFullYear(Number(year));
      return newDate;
    } catch (err) {
      return new Date();
    }
  }

  static validateEmail(email: string) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  static generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime(); //Timestamp
    var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16; //random number between 0 and 16
      if (d > 0) {
        //Use timestamp until depleted
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        //Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  static retrieveBrowser() {
    var ua = navigator.userAgent,
      tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: "IE", version: tem[1] || "" };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return { name: "Opera", version: tem[1] };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1],
    };
  }

  static getDateFromTimestamp(data: any): Date | undefined {
    if (data instanceof Date) {
      return data;
    } else if (data instanceof Timestamp) {
      return data.toDate();
    } else if (typeof data === "number") {
      const date = new Date(data);
      if (date.getTime() > 0) {
        return date;
      }
    } else if (typeof data === "string") {
      const date = new Date(data);
      if (date.getTime() > 0) {
        return date;
      }
    }
    return undefined;
  }

  static isValidString(value: any) {
    return (typeof value === "string" || value instanceof String) && value !== "";
  }
  static isValidNumber(value: any) {
    return typeof Utilities.convertToNumber(value) === "number" && isFinite(Utilities.convertToNumber(value));
  }
  static isValidObject(value: any) {
    return value && typeof value === "object" && value.constructor === Object;
  }

  /**
   *
   * @param access read access object
   * @param settings option to exclude property roles
   * @returns a string with all the roles, contractor groups, properties, companies, users, property units and property roles
   * @deprecated use useReadAccessText hook instead
   */
  static getFullReadAccessString(access: ReadAccess | undefined, settings?: { excludePropertyRoles?: boolean }): string {
    let value: string[] = [];
    if (!access) return "";

    // Collect all roles
    if (access.roles && access.roles.length > 0) {
      value.push(...access.roles.map((role) => getPluralRoleTitle(role.id, getCachedApiSettings({})?.data)));
    }

    // Collect contractor groups
    if (access.contractorGroups && access.contractorGroups.length > 0) {
      value.push(...access.contractorGroups.map((c) => c.name));
    }

    // Collect properties
    if (access.properties && access.properties.length > 0) {
      value.push(...access.properties.map((c) => c.name));
    }

    // Collect companies
    if (access.companies && access.companies.length > 0) {
      value.push(...access.companies.map((c) => c.name));
    }

    // Collect users
    if (access.users && access.users.length > 0) {
      value.push(...access.users.map((c) => c.name));
    }

    // Collect property units
    if (access.propertyUnits && access.propertyUnits.length > 0) {
      value.push(...access.propertyUnits.map((c) => c.name));
    }

    // Collect property roles if not excluded
    if (access.propertyRoles && access.propertyRoles.length > 0 && !settings?.excludePropertyRoles) {
      const propertyRoles = access.propertyRoles.sort((a, b) => a.property.name.localeCompare(b.property.name));
      const groupedPropertyRoles: { [key: string]: { roles: string[]; property: PropertyData } } = {};
      for (const propertyRole of propertyRoles) {
        if (!groupedPropertyRoles[propertyRole.property.id]) {
          groupedPropertyRoles[propertyRole.property.id] = { roles: [], property: propertyRole.property };
        }
        groupedPropertyRoles[propertyRole.property.id].roles.push(getPluralRoleTitle(propertyRole.role.id, undefined));
      }
      value.push(...Object.values(groupedPropertyRoles).map((c) => c.property.name + " (" + c.roles.join(", ") + ")"));
    }

    // Return the full concatenated string
    return value.join(", ");
  }
}

export const convertToOrdinal = (number: number) => {
  const currentLocale = getCurrentNormalizedLanguageCode();
  switch (currentLocale) {
    case "no":
      return number + ".";
    default:
      const suffixes = ["th", "st", "nd", "rd"];
      const v = number % 100;
      return number + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
  }
};

export const replaceUndefinedValuesWithValueFromObject = (object: { [key: string]: any }, value: any) => {
  const result: { [key: string]: any } = {};

  for (const key in object) {
    result[key] = object[key] === undefined ? value : object[key];
  }

  return result;
};

/**
 * Removes all undefined values from an object or array
 * @param object The object or array to remove undefined values from
 * @param isRecursive Whether to recursively remove undefined values from nested objects/arrays (default: false)
 * @returns A new object or array with all undefined values removed
 * @example
 * // Non-recursive object
 * removeUndefinedValuesFromObject({ a: 1, b: undefined, c: 3 }) // { a: 1, c: 3 }
 *
 * // Recursive object
 * removeUndefinedValuesFromObject({ a: 1, b: { c: undefined, d: 2 }, e: undefined }, true)
 * // { a: 1, b: { d: 2 } }
 *
 * // Array support
 * removeUndefinedValuesFromObject([1, undefined, { a: 1, b: undefined }], true)
 * // [1, { a: 1 }]
 */
export const removeUndefinedValuesFromObject = <T extends object>(object: T, isRecursive: boolean = false): T => {
  // Handle arrays
  if (Array.isArray(object)) {
    return object
      .filter((item) => item !== undefined)
      .map((item) => {
        if (isRecursive && typeof item === "object" && item !== null) {
          return removeUndefinedValuesFromObject(item as object, true);
        }
        return item;
      }) as unknown as T;
  }

  // Handle objects
  const result: T = {} as T;
  for (const key in object) {
    if (object[key] !== undefined) {
      if (isRecursive && typeof object[key] === "object" && object[key] !== null) {
        if (object[key] instanceof DocumentReference) {
          result[key] = object[key];
        } else {
          result[key] = removeUndefinedValuesFromObject(object[key] as object, true) as any;
        }
      } else {
        result[key] = object[key];
      }
    }
  }

  return result;
};
